import {apiService} from '../apiService';
import type {Lead} from 'shared-types';

export const leadApi = {
    // GET routes based on actual backend
    getAll: (): Promise<Lead[]> =>
        apiService.get('/leads'),

    getByPage: (page: number, limit: number): Promise<any> =>
        apiService.get(`/leads/by-page?page=${page}&limit=${limit}`),

    search: (text: string): Promise<Lead[]> =>
        apiService.get(`/leads/search?text=${text}`),

    getById: (id: string): Promise<Lead> =>
        apiService.get(`/leads/${id}`),

    getSourcesById: (id: string): Promise<any> =>
        apiService.get(`/leads/sources/${id}`),

    getLeadsToRemind: (): Promise<Lead[]> =>
        apiService.get('/leads/reminders/open'),

    // POST routes
    create: (lead: Partial<Lead>): Promise<Lead> =>
        apiService.post('/leads', lead),

    uploadExcel: (file: File): Promise<any> =>
        apiService.uploadFile('/leads/upload/excel', file),

    uploadCsv: (file: File): Promise<any> =>
        apiService.uploadFile('/leads/upload/csv', file),

    addInteraction: (leadId: string, interaction: any): Promise<any> =>
        apiService.post(`/leads/${leadId}/addInteraction`, interaction),

    updateInteraction: (interactionId: string, interaction: any): Promise<any> =>
        apiService.patch(`/interaction/${interactionId}`, interaction),

    // PATCH routes
    update: (id: string, lead: Partial<Lead>): Promise<Lead> =>
        apiService.patch(`/leads/${id}`, lead),

    // DELETE routes
    delete: (id: string): Promise<void> =>
        apiService.delete(`/leads/${id}`),

    deleteInteraction: (leadId: string, interactionId: string): Promise<void> =>
        apiService.delete(`/leads/${leadId}/interactions/${interactionId}`),
};